import React from "react";
import WizardConfirmation from "@am/multi_step_forms/WizardConfirmation";

export default function SuccessScreen({ confirmationCta }) {
	const cta = confirmationCta || {};
	return (
		<WizardConfirmation
			className="wizard-confirmation"
			title="Submission received"
			message="Thanks for sharing your treasured find with the Australian Museum."
			ctaUrl={cta.url}
			ctaLabel={cta.label}
		/>
	);
}
